import { render, staticRenderFns } from "./FormacionYCategoriaProfesional.vue?vue&type=template&id=0f7a7f9c&"
import script from "./FormacionYCategoriaProfesional.vue?vue&type=script&lang=js&"
export * from "./FormacionYCategoriaProfesional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports